/**
 * Assignment + payment column display config.
 *
 * The `*_COLORS` maps keep their names and their job — one file decides what
 * colour a status reads as — but since #443 each value is a tone class from
 * `status-badge.module.css` rather than a Tailwind pair. The tone, not the
 * shape: a call site composes `cx(badge.badge, MAP[status])` for the pill,
 * exactly as `PHASE_COLORS` is composed, so the two vocabularies cannot drift
 * into two different pills. The maps stay one-per-vocabulary so the lockstep
 * test (a colour AND a label for every status) still has two sides to compare.
 */
import badge from "./status-badge.module.css";

export const ASSIGNMENT_STATUS_COLORS: Record<string, string> = {
  pending: badge.yellow,
  notified: badge.blue,
  accepted: badge.green,
  declined: badge.red,
  cancelled: badge.gray,
};

export const ASSIGNMENT_STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  notified: "Notified",
  accepted: "Accepted",
  declined: "Declined",
  cancelled: "Cancelled",
};

export const PAYMENT_STATUS_COLORS: Record<string, string> = {
  pending: badge.yellow,
  client_confirmed: badge.orange,
  paid: badge.green,
  deposit_paid: badge.blue,
  awaiting_bank_transfer: badge.yellow,
  invoiced: badge.purple,
  not_sent: badge.gray,
  not_due: badge.gray,
};

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  client_confirmed: "Client Confirmed",
  paid: "Paid",
  deposit_paid: "Deposit Paid",
  awaiting_bank_transfer: "Awaiting Payment",
  invoiced: "Invoiced",
  not_sent: "Not Sent",
  not_due: "Not Due",
};
